import React from 'react';
import { useParams } from 'react-router-dom';
import PublicArticleView from "../features/articles/views/public-article-view";
import ArticleToPrintModal from "../features/articles/components/article-to-print-modal";
import ArticleQrInfoModal from "../features/articles/components/article-qr-info-modal";

const PublicArticlePage: React.FC = () => {
    const { articleTitle, appId } = useParams<{ articleTitle: string, appId: string }>();
    return (
        <div className="w-full max-h-full">
            <div className="px-6 py-[40px] pb-[96px] max-w-[1800px] mx-auto">
                <PublicArticleView articleTitle={articleTitle} appId={appId} />
            </div>
            <ArticleToPrintModal />
            <ArticleQrInfoModal />
        </div>
    );
};

export default PublicArticlePage;


